import { getGeoLocationFiltersFromSearchState } from './getGeoLocationFiltersFromSearchState'
import {
  DEFAULT_RESULTS_PER_PAGE,
  DEFAULT_AROUND_RADIUS_IN_METERS,
  DEFAULT_SORT_ORDER
} from '../../domain/search/constants'
import { addOptionalFilters } from '@/domain/search/addOptionalFilters'
import { isNonEmptyArray } from '@/utils/checks'
import { getAdOpsCookie } from '../../domain/useCases/adminBarInfo/adminBarUtils'
import { AROUND_RADIUS_GLOBAL } from '@/constants/searchRadius'
import removeEmptyKeysAndValues from '../removeEmptyKeysAndValues'
export const generateAlgoliaConfigurationFromSearchState = (
  searchState,
  { resultsPerPage, aroundRadius, primaryFocus, modifyFilters, isAdOps } = {
    resultsPerPage: DEFAULT_RESULTS_PER_PAGE,
    primaryFocus: '',
    modifyFilters: false,
    isAdOps: !!getAdOpsCookie()
  }
) => {
  const hitsPerPage = resultsPerPage || DEFAULT_RESULTS_PER_PAGE

  const configure = {
    ...(searchState?.configure || {}),
    facetingAfterDistinct: true,
    highlightPreTag: '<span class="font-semibold">',
    highlightPostTag: '</span>',
    filters: 'NOT status:"Closed" AND NOT status:hidden AND NOT status:draft',
    optionalFilters: addOptionalFilters({ searchState, primaryFocus }),
    ranking: DEFAULT_SORT_ORDER,
    sumOrFiltersScores: true,
    hitsPerPage,
    numericFilters: ['qualityScore:6.0 to 0'],
    getRankingInfo: isAdOps || !!searchState?.configure?.aroundLatLng
  }

  if (!configure.aroundLatLng) {
    return configure
  }

  if (configure.aroundLatLng) {
    configure.aroundRadius = [aroundRadius, configure.aroundRadius].includes(
      AROUND_RADIUS_GLOBAL
    )
      ? AROUND_RADIUS_GLOBAL
      : parseInt(aroundRadius || configure.aroundRadius) ||
        DEFAULT_AROUND_RADIUS_IN_METERS
    configure.aroundPrecision = [aroundRadius, configure.aroundRadius].includes(
      AROUND_RADIUS_GLOBAL
    )
      ? null
      : parseInt(aroundRadius || configure.aroundRadius) ||
        DEFAULT_AROUND_RADIUS_IN_METERS
  }

  const locationName = searchState?.locationName
    ? searchState.locationName
    : searchState?.refinementList?.locations?.[0]

  if (locationName) {
    let geoLocationFilters = [configure.filters]
    geoLocationFilters = geoLocationFilters.concat(
      getGeoLocationFiltersFromSearchState(searchState)
    )
    configure.filters = geoLocationFilters.join(' AND ')
  }

  if (
    isNonEmptyArray(searchState?.configure?.optionalFilters) &&
    searchState?.configure?.optionalFilters.length > 4
  ) {
    configure.optionalFilters = searchState?.configure?.optionalFilters
  }

  if (modifyFilters) {
    configure.optionalFilters = searchState?.configure?.optionalFilters
    configure.facetFilters = searchState?.configure?.facetFilters
  }
  if (configure?.customLocationRadiusInMiles) {
    const { customLocationRadiusInMiles, ...config } = configure
    return config
  }
  return removeEmptyKeysAndValues(configure)
}
